import { AppContext } from '@lightspeed-invoicing/core-client/frontend/index'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import {
    Link
} from 'react-router-dom'
import Icon from "../../common/icon/icon.component.jsx"
import Image from "../../common/image/image.component.jsx"
import ProposalOptionName from "../../common/proposal/optionname.component.jsx"
import ProposalColorPreview from "./colorPreview.component.jsx"

class ProposalOptionsSection extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            options: [],
        }
        this.supportedOptions = [
            'primary-color',
            'secondary-color',
            'group-title-background-color',
            'button-color',
            'banner-color',
            'background-color',
            'background-image-id',
            'font',
            'additional-color-1',
            'additional-color-2',
            'additional-color-3',
            'print-size',
        ]
    }

    componentDidMount() {
        Promise.all(this.supportedOptions.map(optionKey =>
            AppContext.getApiClient().get('/default-proposal-options/' + optionKey)
        )).then(results => this.setState({options: results}))
    }

    renderOptionValue(option) {
        let value = ''
        switch (option.attributes.type) {
            case 'boolean':
                if (option.attributes.value) {
                    value = <Icon value={"eye"}/>
                } else {
                    value = <Icon value={"eye-slash"}/>
                }
                break
            case 'string':
            case 'integer':
                value = option.attributes.value
                break
        }

        if (option.attributes.optionKey === 'primary-color' ||
            option.attributes.optionKey === 'secondary-color' ||
            option.attributes.optionKey === 'banner-color' ||
            option.attributes.optionKey === 'group-title-background-color' ||
            option.attributes.optionKey === 'button-color' ||
            option.attributes.optionKey === 'additional-color-1' ||
            option.attributes.optionKey === 'additional-color-2' ||
            option.attributes.optionKey === 'additional-color-3' ||
            option.attributes.optionKey === 'background-color'
        ) {
            value = <div>
                <div className="mr-2" style={{
                    backgroundColor: value,
                    width: '70px',
                    height: '30px',
                }}>&nbsp;</div>
                {value}
            </div>
        }
        if (option.attributes.optionKey === 'background-image-id') {
            value = <div>
                {option.attributes.value ? <Image imageId={option.attributes.value} size={'very-small'}/> : ''}
            </div>
        }
        return <dd className="col-sm-6" key={option.id + '_value'}>{value}</dd>
    }

    renderOptionLabel(option) {
        return <dt key={option.id + '_label'} className="col-sm-6">
            <ProposalOptionName value={option.attributes.optionKey} />
        </dt>
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="m-0 custom-lead">
                                    <FormattedMessage
                                        id='settings.general.options.title'
                                        defaultMessage='General options'
                                    />
                                </h2>
                            </div>
                            <div className="col-4 justify-content-end action-bar text-right">
                                <Link to="/settings/editProposalOptions" className="btn btn-primary btn-sm">
                                    <Icon value={"edit"}/>
                                    <FormattedMessage
                                        id="settings.edit_proposal_options_btn"
                                        defaultMessage="Edit Options"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className={"row"}>
                            <div className={"col-md-6"}>
                                <dl className="row">
                                    {this.state.options.map(option => [
                                        this.renderOptionLabel(option),
                                        this.renderOptionValue(option),
                                    ])}
                                </dl>
                            </div>
                            <div className="col-md-6 pr-5">
                                <ProposalColorPreview options={this.state.options} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default ProposalOptionsSection


// WEBPACK FOOTER //
// ./src/settings/proposals/optionsSection.component.jsx